import * as actionTypes from '../../action/emailtemplates/EmailTemplates'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: ''
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_GETEMAILTEMPLATE_FETCH:
            return {
                ...state,
                isFetching: true
            };
        case actionTypes.GET_GETEMAILTEMPLATE_SUCCESS :
            return {
                ...state,
                isFetching: false,
                error: false,
                emailtemplates: action.payload
            };
        
        case actionTypes.GET_GETEMAILTEMPLATE_FAILURE :
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_GETEMAILTEMPLATE_MESSAGE:
            return {
                ...state,
                isFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;